import React from 'react';

export default function SettingsBox({ title, children }) {
  return (
    <div className="SettingsBox">
      <h3>{title}</h3>
      {children}
    </div>
  );
}
